import styled from 'styled-components';

export const MessageContainer = styled.p`
  word-break: break-word;
  hyphens: auto;
  white-space: pre-wrap;
`;
